// components/ActivityInsights/dummyData.js

// components/ActivityInsights/dummyData.js

// 🧱 1. Generate Dummy Events
export function generateDummyEvents(days = 14, countPerDay = 60) {
  const events = [];
  const now = new Date();

  const teams = ["Sales", "Tech", "HR", "Finance"];
  const rooms = Array.from({ length: 10 }, (_, i) => `Room-${i + 1}`);

  for (let d = 0; d < days; d++) {
    const date = new Date();
    date.setDate(now.getDate() - d);

    for (let i = 0; i < countPerDay; i++) {
      const hour = Math.floor(Math.random() * 10) + 8;

      const dayOfWeek = date.getDay();
      const midweekBoost = (dayOfWeek >= 2 && dayOfWeek <= 4) ? 1.3 : 0.8;

      if (Math.random() > midweekBoost) continue;

      const start = new Date(date);
      start.setHours(hour, 0, 0, 0);

      const end = new Date(start);
      end.setHours(hour + 1);

      const workspaceId = rooms[Math.floor(Math.random() * rooms.length)];

      const badRooms = ["Room-3", "Room-7"];

      const isLunch = hour >= 12 && hour <= 13;
      const baseNoShow = isLunch ? 0.35 : 0.2;

      const checkedIn = badRooms.includes(workspaceId)
        ? Math.random() > 0.5
        : Math.random() > baseNoShow;

      events.push({
        bookingId: `${d}-${i}`,
        workspaceId,
        team: teams[Math.floor(Math.random() * teams.length)],
        department: "Dept-" + (Math.floor(Math.random() * 3) + 1),
        startTime: start.toISOString(),
        endTime: end.toISOString(),
        checkedIn
      });
    }
  }

  return events;
}


// 🟦 Day of Week
export function getDOWStats(events) {
  const days = ["Sun","Mon","Tue","Wed","Thu","Fri","Sat"];

  return days.map((day, i) => {
    const dayEvents = events.filter(e =>
      new Date(e.startTime).getDay() === i
    );

    const bookings = dayEvents.length;
    const utilised = dayEvents.filter(e => e.checkedIn).length;

    return {
      label: day,
      bookings,
      utilised,
      utilisationRate: bookings ? utilised / bookings : 0
    };
  });
}

// 🟩 Hour of Day
export function getHODStats(events) {
  const hours = Array.from({ length: 24 }, (_, i) => i);

  return hours.map(hour => {
    const hourEvents = events.filter(e =>
      new Date(e.startTime).getHours() === hour
    );

    const bookings = hourEvents.length;
    const utilised = hourEvents.filter(e => e.checkedIn).length;

    return {
      label: `${hour}:00`,
      bookings,
      utilised,
      utilisationRate: bookings ? utilised / bookings : 0
    };
  });
}

// 🟨 14 Day Trend
export function get14DayTrend(events) {
  const result = [];

  for (let i = 13; i >= 0; i--) {
    const date = new Date();
    date.setDate(date.getDate() - i);

    const dayEvents = events.filter(e => {
      const d = new Date(e.startTime);
      return d.toDateString() === date.toDateString();
    });

    const bookings = dayEvents.length;
    const utilised = dayEvents.filter(e => e.checkedIn).length;

    result.push({
      date: date.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short"
      }),
      bookings,
      utilisation: utilised
    });
  }

  return result;
}


export function buildDOWBullets(stats) {
  return stats.map(d => ({
    label: d.label,
    value: d.utilisationRate,
    target: 0.8,
    ranges: [0.4, 0.7, 1.0]
  }));
}

export function buildHODBullets(stats) {
  return stats.map(h => ({
    label: h.label,
    value: h.utilisationRate,
    target: 0.75,
    ranges: [0.3, 0.6, 1.0]
  }));
}